import React from 'react';
import { styled } from '@mui/system';

const DivFlexEnd = styled('div')((props) =>({
    display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end'
}));

export default DivFlexEnd;